import React from 'react'
import { Box, Avatar } from '@mui/material'
import { AutocompleteAsyncSeeker } from '@ui-seeker/core'
import { getSubmit } from '@ui-seeker/utils'
import { BACKEND_APIS } from '@constants'
import { selectedSku, selectedDays, skuDetailData, isLoading, clearData } from './@signals'

export default function SkuSelector() {
    const handleChange = (e) => {
        const rawValue = e.target.value
        const idSku = typeof rawValue === 'object' ? rawValue?.value : rawValue

        // Ignore empty onChange if we already have data loading or loaded
        if (!idSku && isLoading.value) {
            return
        }

        if (idSku) {
            clearData()
            selectedSku.value = typeof rawValue === 'object' ? rawValue : { value: rawValue }

            const url = `${BACKEND_APIS.SKU_MANAGEMENT}/detail?id_sku=${idSku}&days=${selectedDays.value}`
            isLoading.value = true
            getSubmit(url)
                .then(res => {
                    skuDetailData.value = res
                })
                .catch(err => {
                    console.error('Error fetching SKU detail:', err)
                })
                .finally(() => {
                    isLoading.value = false
                })
        } else if (!isLoading.value && !skuDetailData.value) {
            // Only clear if not loading and no data
            clearData()
            selectedSku.value = null
        }
    }

    return (
        <AutocompleteAsyncSeeker
            urlAjax={`${BACKEND_APIS.AUDIT_LOG}/skus`}
            label="SKU"
            placeholder="Search SKUs by name, EAN or reference..."
            value={selectedSku.value}
            onChange={handleChange}
            queryParam="search"
            sx={{ minWidth: 400 }}
            renderOption={(props, option) => (
                <li {...props} key={option.value}>
                    <Avatar
                        src={option.image_url}
                        variant="rounded"
                        sx={{ width: 40, height: 40, mr: 1.5 }}
                    >
                        -
                    </Avatar>
                    <Box>
                        <Box sx={{ fontWeight: 500 }}>{option.label}</Box>
                        {option.ean && (
                            <Box sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
                                EAN: {option.ean}
                            </Box>
                        )}
                    </Box>
                </li>
            )}
        />
    )
}
